// ─────────────────────────────────────────────────────────────────────────────
// THE BUSINESS'S VAT SETTINGS, FOR THE SCREENS THAT SHOW VAT (item 34).
//
// The server decides (GET /api/invoices/vat, lib/supplier: the business owner's settings for a
// member), so the editor's rate choice, its VAT columns and the Tax summary appear exactly when the
// server would accept and print them. Until that answer arrives the screen reads the person's own
// settings through the same rule (lib/vatRates), which is the answer for everyone who is not a team
// member; `loaded` says which it is. A failed read keeps that reading and says so in the console:
// the server still refuses any VAT the business may not charge, so nothing wrong can be saved.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useCurrentUser } from '../contexts/CurrentUserContext';
import { vatSettings } from './vatRates';

export function useBusinessVat() {
  const { currentUser } = useCurrentUser();
  const prefs = currentUser && currentUser.preferences;
  const [state, setState] = useState(() => ({ vat: vatSettings(prefs), loaded: false }));

  useEffect(() => {
    let live = true;
    setState((s) => ({ ...s, vat: s.loaded ? s.vat : vatSettings(prefs) }));
    api('/api/invoices/vat')
      .then((r) => r.json())
      .then((d) => { if (live && d && d.vat) setState({ vat: d.vat, loaded: true }); })
      .catch((err) => console.error('[vat] the business VAT settings did not load; using your own:', err && err.message));
    return () => { live = false; };
    // Re-read when her saved settings change (Settings, Branding, VAT).
  }, [prefs && prefs.vatRegistered, prefs && prefs.vatNumber, prefs && prefs.vatDefaultRate, prefs && prefs.vatStagger]); // eslint-disable-line react-hooks/exhaustive-deps

  return state;
}
